import React, { useEffect, useState } from "react";
import { useGetUserPackagesQuery, useUpdateUserPackagesMutation } from "../store/api/orderApi";

function Toast({ message, type = "success", onClose }) {
    useEffect(() => {
        const timer = setTimeout(onClose, 2500);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                bottom: 24,
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: type === "success" ? "#103D64" : "#D9534F",
                color: "#fff",
                padding: "12px 18px",
                borderRadius: 10,
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                fontWeight: 600,
                zIndex: 9999,
                animation: "fadeInUp 0.3s ease",
            }}
        >
            {message}
        </div>
    );
}

export default function RepackConsentPage() {
    const [shoesOption, setShoesOption] = useState(0);
    const [bagsOption, setBagsOption] = useState(0);
    const [updateUserPackages] = useUpdateUserPackagesMutation();
    const { data: packages } = useGetUserPackagesQuery();
    const [toast, setToast] = useState(null);

    const [errors, setErrors] = useState({
        shoes: false,
        bags: false,
    });

    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);

            const payload = {
                package_shoes: shoesOption,
                bag_package: bagsOption,
            };

            await updateUserPackages(payload).unwrap();

            setToast({ type: "success", message: "Сохранено успешно" });

        } catch (error) {
            console.error("Ошибка сохранения:", error);

            setToast({ type: "error", message: "Ошибка при сохранении" });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (packages?.success) {
            setBagsOption(packages.result.bag_package)
            setShoesOption(packages.result.package_shoes)
        }
    }, [packages])

    return (
        <>
            <div style={styles.page}>
                <div style={styles.wrapper}>
                    <div style={styles.header}>
                        <h1 style={styles.headerTitle}>Правила переупаковки</h1>
                        <p style={styles.headerSubtitle}>
                            Выберите, что делать с упаковкой товара
                        </p>
                    </div>

                    <div style={styles.infoBox}>
                        <div style={styles.infoTitle}>Важная информация</div>
                        <div style={styles.infoText}>
                            Для некоторых товаров переупаковка помогает уменьшить объемный вес и
                            снизить стоимость доставки. Если оставить товар без переупаковки,
                            стоимость доставки может быть выше из-за объема.
                        </div>
                    </div>

                    <CategoryCard
                        title="Обувь"
                        selected={shoesOption}
                        onSelect={setShoesOption}
                        error={errors.shoes}
                    />

                    <CategoryCard
                        title="Сумки / рюкзаки"
                        selected={bagsOption}
                        onSelect={setBagsOption}
                        error={errors.bags}
                    />

                    <div style={styles.summaryBox}>
                        <div style={styles.summaryTitle}>Согласие клиента</div>
                        <div style={styles.summaryText}>
                            Выбирая вариант переупаковки, клиент подтверждает согласие на
                            вскрытие внешней упаковки для уменьшения объемного веса товара.
                        </div>
                        <div style={styles.summaryText}>
                            При выборе варианта «Оставить как есть» клиент подтверждает, что
                            ознакомлен с возможным увеличением стоимости доставки из-за
                            объемного веса.
                        </div>
                    </div>

                    <button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{
                            ...styles.saveButton,
                            ...(isLoading ? styles.saveButtonDisabled : {}),
                        }}
                    >
                        {isLoading ? "Загрузка..." : "Сохранить"}
                    </button>
                </div>
            </div>
            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    onClose={() => setToast(null)}
                />
            )}
        </>
    );
}

function CategoryCard({ title, selected, onSelect, error }) {
    return (
        <div
            style={{
                ...styles.card,
                ...(error ? styles.cardError : {}),
            }}
        >
            <div style={styles.cardTitle}>{title}</div>

            <OptionButton
                selected={selected === 0}
                title="Переупаковать"
                subtitle="Уменьшить объемный вес, если это возможно"
                onClick={() => onSelect(0)}
            />

            <OptionButton
                selected={selected === 1}
                title="Оставить коробку"
                subtitle="Согласен(а), что доставка может быть дороже из-за объемного веса"
                onClick={() => onSelect(1)}
            />

            {error && (
                <div style={styles.errorText}>Пожалуйста, выберите один вариант</div>
            )}
        </div>
    );
}

function OptionButton({ selected, title, subtitle, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            style={{
                ...styles.optionButton,
                ...(selected ? styles.optionButtonActive : {}),
            }}
        >
            <div style={styles.optionRow}>
                <div
                    style={{
                        ...styles.radio,
                        ...(selected ? styles.radioActive : {}),
                    }}
                >
                    {selected && <div style={styles.radioInner} />}
                </div>

                <div style={{ flex: 1, textAlign: "left" }}>
                    <div
                        style={{
                            ...styles.optionTitle,
                            ...(selected ? styles.optionTitleActive : {}),
                        }}
                    >
                        {title}
                    </div>
                    <div style={styles.optionSubtitle}>{subtitle}</div>
                </div>
            </div>
        </button>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        backgroundColor: "#f5f7fb",
        padding: "24px 16px",
    },

    wrapper: {
        maxWidth: 760,
        margin: "0 auto",
    },

    header: {
        marginBottom: 18,
    },

    headerTitle: {
        margin: 0,
        fontSize: 28,
        fontWeight: 700,
        color: "#103D64",
    },

    headerSubtitle: {
        marginTop: 8,
        marginBottom: 0,
        fontSize: 15,
        color: "#5b7186",
    },

    infoBox: {
        backgroundColor: "#EEF6FD",
        border: "1px solid #D7E9F8",
        borderRadius: 16,
        padding: 16,
        marginBottom: 16,
    },

    infoTitle: {
        color: "#103D64",
        fontSize: 16,
        fontWeight: 700,
        marginBottom: 8,
    },

    infoText: {
        color: "#35546E",
        fontSize: 14,
        lineHeight: 1.6,
    },

    card: {
        backgroundColor: "#ffffff",
        borderRadius: 16,
        padding: 16,
        marginBottom: 16,
        boxShadow: "0 8px 24px rgba(16, 61, 100, 0.08)",
    },

    cardError: {
        border: "1px solid #D9534F",
    },

    cardTitle: {
        color: "#103D64",
        fontSize: 18,
        fontWeight: 700,
        marginBottom: 14,
    },

    optionButton: {
        width: "100%",
        border: "1px solid transparent",
        backgroundColor: "#F3F4F6",
        borderRadius: 14,
        padding: 14,
        cursor: "pointer",
        marginBottom: 10,
        transition: "all 0.2s ease",
    },

    optionButtonActive: {
        backgroundColor: "#E8F1F8",
        border: "1px solid #103D64",
    },

    optionRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: 12,
    },

    radio: {
        width: 22,
        height: 22,
        minWidth: 22,
        borderRadius: "50%",
        border: "2px solid #103D64",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 2,
    },

    radioActive: {
        border: "2px solid #103D64",
    },

    radioInner: {
        width: 10,
        height: 10,
        borderRadius: "50%",
        backgroundColor: "#103D64",
    },

    optionTitle: {
        color: "#103D64",
        fontSize: 15,
        fontWeight: 700,
        marginBottom: 4,
    },

    optionTitleActive: {
        color: "#103D64",
    },

    optionSubtitle: {
        color: "#4E5D6C",
        fontSize: 13,
        lineHeight: 1.5,
    },

    summaryBox: {
        backgroundColor: "#FFF7E8",
        border: "1px solid #F3D9A4",
        borderRadius: 16,
        padding: 16,
        marginBottom: 18,
    },

    summaryTitle: {
        color: "#8A5A00",
        fontSize: 16,
        fontWeight: 700,
        marginBottom: 8,
    },

    summaryText: {
        color: "#6C5220",
        fontSize: 14,
        lineHeight: 1.6,
        marginBottom: 8,
    },

    errorText: {
        color: "#D9534F",
        fontSize: 13,
        marginTop: 4,
    },

    saveButton: {
        width: "100%",
        backgroundColor: "#103D64",
        color: "#fff",
        border: "none",
        borderRadius: 10,
        padding: "14px 18px",
        fontSize: 16,
        fontWeight: 700,
        cursor: "pointer",
    },

    saveButtonDisabled: {
        opacity: 0.7,
        cursor: "not-allowed",
    },
};